import React, { useState } from 'react';
import { Button, Modal, ModalProps } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { createModal } from 'react-modal-promise';
import { VehicleFormPage } from 'shared-pages/pages/vehicles/form/vehicle-form-page';

type Props = {
  readonly open: boolean;
  readonly close: (result: any) => void;
  readonly title: string;
  /** body of dialog */
  readonly collectorId?: number;
} & ModalProps;

const ModalInput = ({ open, close, collectorId }: Props) => {
  const { t } = useTranslation();

  return (
    <>
      <Modal size="xl" show={open} centered backdrop="static">
        <VehicleFormPage
          isModal={true}
          paramId={'-1'}
          paramCollectorId={collectorId}
          modalOnClose={(id) => {
            if (id < 0) close(false);
            close(id);
          }}
        />
      </Modal>
    </>
  );
};

export const promiseModalVehicleInput = createModal(ModalInput);

